'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = require('../../../../Input/Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var EveryHour = function (_Component) {
  _inherits(EveryHour, _Component);

  function EveryHour() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EveryHour);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EveryHour.__proto__ || Object.getPrototypeOf(EveryHour)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hours: ''
    }, _this.convert = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$hours = _ref2.hours,
          hours = _ref2$hours === undefined ? _this.state.hours : _ref2$hours;

      _this.setState({
        hours: hours
      });

      _this.props.onChange(!!hours ? '0 0 0/' + hours + ' 1/1 * ? *' : null);
    }, _this.onChange = function (value) {
      var formattedValue = ('' + value).replace(/[^0-9]/g, '');
      if (_this.state.hours === formattedValue) return;

      _this.convert({
        hours: formattedValue
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EveryHour, [{
    key: 'render',
    value: function render() {
      var disabled = this.props.disabled;
      var hours = this.state.hours;
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_Input2.default, {
        value: hours,
        onChange: this.onChange,
        disabled: disabled
      }, 'Every how many Hours?'));
    }
  }]);

  return EveryHour;
}(_react.Component);

EveryHour.propTypes = {
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};
EveryHour.key = 'everyHour';
EveryHour.label = 'Every Specified Hour';
exports.default = EveryHour;